export function getCores(): number {
    return navigator.hardwareConcurrency;
}
